import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { Application, Project } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-query-applicant',
  templateUrl: './query-applicant.component.html',
  styleUrls: ['./query-applicant.component.css']
})
export class QueryApplicantComponent implements OnInit {

  ProjectNameList: any;
  CategoryList: any;
  GetApplicantTransactionDetails: any;
  DebitTotal: number;
  CreditTotal: number;
  ClosingBalance: number;
  ApplicantQuery;
  PropertyDetails;
  PropertyDetailsByid;
  a: Application;
  p: Project;
  isApp: boolean;
  isProp: boolean;
  showAppDetails: any;
  showpropertysection: any;
  showappdetails: any;
  showpropdetails: any;
  showfindetails: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems: number=null;
  AFD: any;
  Prop: any;
  data: any;
  PD: any;
  encode: string;
  Appno: any;
  s: any = [];
   userName: any;
  isPrintMode: boolean = false;
  selectedApplicationNumber: any;


  constructor(private userService: UserService, private errorHandler: ErrorHandler) {
    this.showAppDetails = true;
    this.showpropertysection = false;
    this.a = new Application();
    this.isApp = false;
    this.p = new Project();
    this.isProp = false;
    this.showappdetails = false;
    this.showpropdetails = false;
    this.showfindetails = false;
    
  }

  ngOnInit() {
    // this.GetApplicantDetails(this.Appno)
    this.userName = localStorage.getItem('userName');
    this.GetByIdInstallpaymentApplicant(this.userName);
  }
  // myFunction(){
  //   window.print();
  // }

  pageChanged(pageNumber: number) {
    
    // if (this.isSearch)
    //   this.onSearch(this.s, this.itemsPerPage, pageNumber);
    // else
    if(pageNumber.toString()!="NaN")
      this.GetPropertyDetails(this.p,this.itemsPerPage, pageNumber);
      else
      return false;
  }
  
  SelectOption(option) {
    //alert(option);
    if (option == "Application") {
      this.showAppDetails = true;
      this.showappdetails = false;
      this.showfindetails = false;
      this.showpropertysection = false;
      this.Resetform();
      this.ResetPropform();
    }
    else {
      this.GetAllProjectsName();
      this.showAppDetails = false;
      this.showpropertysection = true;
      this.totalItems=null;
    }
  }

  GetApplicantDetails(a) {
    //alert(a);
   
    // this.encode=encodeURIComponent(this.a.ApplicationNo);
    this.isApp = false;
    if (this.a.ApplicationNo == null || this.a.ApplicationNo == '') { var Appno = 'empty'; }
    else {
      Appno = this.a.ApplicationNo;
    }
    if (this.a.RegNo == null || this.a.RegNo == '') { var RegNo = 'empty'; }
    else {
      RegNo = this.a.RegNo;
    }
    // if (this.a.MobileNumber == null || this.a.MobileNumber == '') { var PhoneNo = 0; }
    // else {
    //   PhoneNo = this.a.MobileNumber;
    // }
    // if (this.a.ApplicantName == null || this.a.ApplicantName == '') { var Namee = 'empty'; }
    // else {
    //   Namee = this.a.ApplicantName;
    // }
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetApplicantDetails_self(Appno, RegNo)
      .subscribe(
        (data: any) => {
          
          document.getElementById('loader-spinner').style.display = "none";
          this.ApplicantQuery = data.ApplicationQuery;
              
           const selected = this.s[0].find(x => x.APP_No == Appno);
          this.selectedApplicationNumber = selected ? selected.APP_No : '';
          console.log('selected',this.selectedApplicationNumber);
          console.log(this.ApplicantQuery);
          // this.totalItems = data.TotalItemsCount;
          // this.itemsPerPage = itemsPerPage;
          // this.currentPage = pageNo;
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError("error");
        });
  }

  GetApplicantDetailsById(APP_Id) {
    this.showappdetails = true;
    this.showfindetails = true;
    //alert(APP_Id);
    this.GetApplicantTransactionDetailsQuery(APP_Id);
    this.GetApplicationScrutinyQueryDetails(APP_Id);
    this.getAppViewProjectQueryDetails(APP_Id);
  }

  GetApplicationScrutinyQueryDetails(APP_Id) {
    
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetApplicationScrutinyQueryDetails_self(APP_Id);
    this.data.subscribe(
      (response: any) => {
        this.AFD = response;
        if (this.AFD.APP_IsJoint == 'N')
          this.AFD.APP_IsJoint = 'No';
        else
          this.AFD.APP_IsJoint = 'Yes';
       
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  getAppViewProjectQueryDetails(APP_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAppViewProjectQueryDetails_self(APP_Id);
    this.data.subscribe(
      (response: any) => {
        this.PD = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetApplicantTransactionDetailsQuery(APP_Id) {
    this.GetApplicantTransactionDetails=null;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetApplicantTransactionDetailsQuery_self(APP_Id)
      .subscribe(
        (data: any) => {
          this.GetApplicantTransactionDetails = data.TransactionModels;
          // this.totalItems = data.TotalItemsCount;
          // this.itemsPerPage = itemsPerPage;
          // this.currentPage = pageNo;
          this.GetDebitTotal();
          this.GetCreditTotal();
          this.GetClosingBalance();
          this.GetApplicantTransactionDetails.forEach((item: any) => {
          if (item.Amount_type === 'Reg_Fee') {
              item.Amount_type = 'Registration Fee';
          } else if (item.Amount_type === 'App_Fee') {
              item.Amount_type = 'Application Fee';
          } else if (item.Amount_type === 'Initial_Deposit') {
              item.Amount_type = 'Initial Deposit';
              //this.initialdepositamount = item.Debit
          }
          });
          document.getElementById('loader-spinner').style.display = "none";
        }, (error: any) => {
          swal('Warning!', "This Page is for applicant", 'warning');
          // document.getElementById('loader-spinner').style.display = "none";
        });
  }

  GetDebitTotal() {
    
    let totals = 0;
    for (let i = 0; i < this.GetApplicantTransactionDetails.length; i++) {
      totals += this.GetApplicantTransactionDetails[i].Debit;
    }
    this.DebitTotal = totals;
  }

  GetCreditTotal() {
    let totals = 0;
    for (let i = 0; i < this.GetApplicantTransactionDetails.length; i++) {
      totals += this.GetApplicantTransactionDetails[i].Credit;
    }
    this.CreditTotal = totals;
  }

  GetClosingBalance() {
    this.ClosingBalance = this.DebitTotal - this.CreditTotal;
  }

  GetAllProjectsName() {
    
    document.getElementById('loader-spinner').style.display = "block";
    //this.data = this.userService.getAllProjects();
    this.data = this.userService.getAllProjectsBasedOnRole_self();    
    console.log(this.data);
    this.data.subscribe(
      (response: any) => {
        this.ProjectNameList = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error: any) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }


  GetAllCategories(PD_Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getCategory_self(PD_Id);
    console.log(this.data);
    this.data.subscribe(
      (response: any) => {
        this.CategoryList = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error: any) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }

  GetPropertyDetails(p,itemsPerPage,pageNo) {
    
    this.isProp = false;
    if (this.p.PD_Id == null || this.p.PD_Id == '') { var PDId = 'empty'; }
    else {
      PDId = this.p.PD_Id;
    }
    if (this.p.PropNo == null || this.p.PropNo == '') { var PropertyNo = 'empty'; }
    else {
      PropertyNo = this.p.PropNo;
    }
    if (this.p.CA_CategoryName == null || this.p.CA_CategoryName == '') { var Catgry = 'empty'; }
    else {
      Catgry = this.p.CA_CategoryName.substring(0, 3);
    }
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetPropertyDetailsQuery_self(PDId, PropertyNo, Catgry,itemsPerPage,pageNo)
      .subscribe(
        (data: any) => {
          
          this.PropertyDetails = data.projectsModels;
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.handleError(error);
        });

        
  }

  GetPropertyDetailsById(PR_Id) {
    
    this.showpropdetails = true;
    this.showappdetails = true;
    this.showfindetails = true;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetPropertyDetailsById(PR_Id)
    this.data.subscribe(
      (response: any) => {
        this.Prop = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error: any) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }

  Resetform() {
    
    this.showappdetails = false;
    this.showfindetails = false;
    //this.showpropdetails = false;
    //this.ApplicantQuery = [];
    //this.a.ApplicationNo = '';
    //this.a.RegNo = '';
    //this.a.MobileNumber = '';
    //this.a.ApplicantName = '';
  }

  ResetPropform() {
    this.showpropdetails = false;
    //this.PropertyDetails = [];
    //this.p.PD_Id = '';
    //this.p.PropNo = '';
   // this.p.CA_CategoryName = '';
  }

  GetByIdInstallpaymentApplicant(userName) {
   
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetInstallPaymentDetailsforApplicant(userName);
    this.data.subscribe(
      (response: any) => {
         if (!response || response.length === 0) {
        console.warn("Application not found");
        document.getElementById('loader-spinner').style.display = "none";
        return;
      }
        this.s = response;
        console.log(this.s);
        this.p.PropNo = this.s[0].PR_Property_No;
        this.a.ApplicationNo = this.s[0].APP_No;
        console.log(' data1 :' + JSON.stringify(this.s.APP_Id));
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }

  
// print(): void {
//   this.isPrintMode = true;

//   setTimeout(() => {
//     const printContents = document.getElementById('print-section').innerHTML;
//     const stylesHtml = this.getTagsHtml('style');
//     const linksHtml = this.getTagsHtml('link');
//     const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

//     const customPrintStyle = `
//     <style>
//     @media print {
//       @page {
//         size: landscape;
//         margin: 1cm;
//       }

//       body {
//         zoom: 0.81;
//       }

//       table {
//         width: 100% !important;
//         table-layout: fixed;
//         word-wrap: break-word;
//       }

//       th, td {
//         font-size: 12px;
//         padding: 4px;
//         word-break: break-word;
//         text-align: center;
//       }

//       input, select, button {
//         display: none !important;
//       }

//       .no-print {
//         display: none !important;
//       }
//     }
//   </style>
//     `;

//     popupWin.document.open();
//     popupWin.document.write(`
//       <html>
//         <head>
//           <title>Application Details</title>
//           ${linksHtml}
//           ${stylesHtml}
//           ${customPrintStyle}
//         </head>
//         <body onload="window.print(); window.close()">
//           ${printContents}
//         </body>
//       </html>
//     `);
//     popupWin.document.close();

//     this.isPrintMode = false;
//   }, 0);
// }




//   printfin(): void {
//     this.showfindetails = true;
//     this.isPrintMode = true;
    

//   setTimeout(() => {
//     const printContents = document.getElementById('print-section1').innerHTML;
//     const stylesHtml = this.getTagsHtml('style');
//     const linksHtml = this.getTagsHtml('link');
//     const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

//     const customPrintStyle = `
//     <style>
//     @media print {
//       @page {
//         size: landscape;
//         margin: 1cm;
//       }

//       body {
//         zoom: 0.81;
//       }

//       table {
//         width: 100% !important;
//         table-layout: fixed;
//         word-wrap: break-word;
//       }

//       th, td {
//         font-size: 12px;
//         padding: 4px;
//         word-break: break-word;
//         text-align: center;
//       }

//       input, select, button {
//         display: none !important;
//       }

//       .no-print {
//         display: none !important;
//       }
//     }
//   </style>
//     `;

//     popupWin.document.open();
//     popupWin.document.write(`
//       <html>
//         <head>
//           <title>Applicant Finance Details</title>
//           ${linksHtml}
//           ${stylesHtml}
//           ${customPrintStyle}
//         </head>
//         <body onload="window.print(); window.close()">
//           ${printContents}
//         </body>
//       </html>
//     `);
//     popupWin.document.close();

//     this.isPrintMode = false;
//   }, 0);
// }



// printprop(): void {
//   this.isPrintMode = true;

//   setTimeout(() => {
//     const printContents = document.getElementById('print-section').innerHTML;
//     const stylesHtml = this.getTagsHtml('style');
//     const linksHtml = this.getTagsHtml('link');
//     const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

//     const customPrintStyle = `
//     <style>
//     @media print {
//       @page {
//         size: landscape;
//         margin: 1cm;
//       }

//       body {
//         zoom: 0.81;
//       }

//       table {
//         width: 100% !important;
//         table-layout: fixed;
//         word-wrap: break-word;
//       }

//       th, td {
//         font-size: 12px;
//         padding: 4px;
//         word-break: break-word;
//         text-align: center;
//       }

//       input, select, button {
//         display: none !important;
//       }

//       .no-print {
//         display: none !important;
//       }
//     }
//   </style>
//     `;

//     popupWin.document.open();
//     popupWin.document.write(`
//       <html>
//         <head>
//           <title>Property Details</title>
//           ${linksHtml}
//           ${stylesHtml}
//           ${customPrintStyle}
//         </head>
//         <body onload="window.print(); window.close()">
//           ${printContents}
//         </body>
//       </html>
//     `);
//     popupWin.document.close();

//     this.isPrintMode = false;
//   }, 0);
// }





print(): void {
 this.showfindetails = true;
 this.isPrintMode = true;

 setTimeout(() => {
const element = document.getElementById('print-section');
const printContents = element ? element.innerHTML : '';



 const stylesHtml = this.getTagsHtml('style');
 const linksHtml = this.getTagsHtml('link');

 const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

 const customPrintStyle = `
 <style>
 @media print {

 .field-title, 
 .field-value {
 display: inline-block !important;
 vertical-align: top !important;
 padding: 4px 6px !important;
 }

 .field-title {
 width: 35% !important;
 font-weight: bold !important;
 }

 .field-value {
 width: 60% !important;
 }

 .col-md-3 {
 display: block !important;
 width: 50% !important; /* 2 items per row */
 float: left !important;
 }

 .row::after {
 content: "";
 display: block;
 clear: both;
 }
 }
 </style>
`;



 popupWin.document.open();
 popupWin.document.write(`
 <html>
 <head>
 <title>Applicant App Details</title>
 ${linksHtml}
 ${stylesHtml}
 ${customPrintStyle}
 </head>
 <body onload="setTimeout(() => { window.print(); window.close(); }, 500)">
 ${printContents}
 </body>
 </html>
 `);

 popupWin.document.close();
 this.isPrintMode = false;
 }, 200);
}

 printfin(): void {
 this.showfindetails = true;
 this.isPrintMode = true;
 

 setTimeout(() => {
 const printContents = document.getElementById('print-section1').innerHTML;
 const stylesHtml = this.getTagsHtml('style');
 const linksHtml = this.getTagsHtml('link');
 const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

 const customPrintStyle = `
 <style>
 @media print {
 @page {
 size: landscape;
 margin: 1cm;
 }

 body {
 zoom: 0.81;
 }

 table {
 width: 100% !important;
 table-layout: fixed;
 word-wrap: break-word;
 }

 th, td {
 font-size: 12px;
 padding: 4px;
 word-break: break-word;
 text-align: center;
 }

 input, select, button {
 display: none !important;
 }

 .no-print {
 display: none !important;
 }
 }
 </style>
 `;

 popupWin.document.open();
 popupWin.document.write(`
 <html>
 <head>
 <title>Applicant Finance Details</title>
 ${linksHtml}
 ${stylesHtml}
 ${customPrintStyle}
 </head>
 <body onload="window.print(); window.close()">
 ${printContents}
 </body>
 </html>
 `);
 popupWin.document.close();

 this.isPrintMode = false;
 }, 0);
}



printprop(): void {
 this.isPrintMode = true;

 setTimeout(() => {
 const printContents = document.getElementById('print-section').innerHTML;
 const stylesHtml = this.getTagsHtml('style');
 const linksHtml = this.getTagsHtml('link');
 const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

 const customPrintStyle = `
<style>
@media print {

 @page {
 size: landscape;
 margin: 1cm;
 }

 body {
 zoom: 0.82;
 }

 /* Force grid to stay in 2 columns */
 .col-md-3 {
 width: 25% !important;
 float: left !important;
 box-sizing: border-box;
 }

 .field-title,
 .field-value {
 display: inline-block !important;
 width: 100% !important;
 font-size: 13px !important;
 padding: 3px 0 !important;
 word-break: break-word !important;
 }

 /* Prevent extra page breaks */
 .row {
 page-break-inside: avoid !important;
 }

 /* Hide unwanted elements */
 input, select, button, .no-print {
 display: none !important;
 }

 table {
 width: 100% !important;
 table-layout: fixed !important;
 }

 td, th {
 padding: 4px !important;
 font-size: 12px !important;
 word-break: break-word !important;
 }
}
</style>
`;


 popupWin.document.open();
 popupWin.document.write(`
 <html>
 <head>
 <title>Property Details</title>
 ${linksHtml}
 ${stylesHtml}
 ${customPrintStyle}
 </head>
 <body onload="window.print(); window.close()">
 ${printContents}
 </body>
 </html>
 `);
 popupWin.document.close();

 this.isPrintMode = false;
 }, 0);
}






















    private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
    const htmlStr: string[] = [];
    const elements = document.getElementsByTagName(tagName);
    for (let idx = 0; idx < elements.length; idx++) {
      htmlStr.push(elements[idx].outerHTML);
    }

    return htmlStr.join('\r\n');
  }


   








}



// WEBPACK FOOTER //
// ./src/app/applicant/query-applicant/query-applicant.component.ts